import { Helmet } from 'react-helmet';
import Sanctions from 'src/features/Sanctions';
import MainLayout from "src/layouts";
import MainContainer from "src/components/common/MainContainer";

const SanctionsPage = () => {
  return (
    <MainLayout>
      <Helmet title="Sanctions" />
      <MainContainer sx={{ mt: 2 }}>
        <Sanctions />
      </MainContainer>
    </MainLayout>
  );
};

export default SanctionsPage;
